import { Fragment } from "react";
import { ExternalLink, Phone, Reply, Store, UserRound } from "lucide-react";
import { LINK_EXEMPLO } from "./modelos";

// *negrito* e _itálico_ do WhatsApp, só pra prévia.
function formatar(texto, chave) {
  return texto.split(/(\*[^*\n]+\*|_[^_\n]+_)/g).map((p, i) => {
    if (/^\*[^*]+\*$/.test(p)) return <strong key={`${chave}-${i}`}>{p.slice(1, -1)}</strong>;
    if (/^_[^_]+_$/.test(p)) return <em key={`${chave}-${i}`}>{p.slice(1, -1)}</em>;
    return <Fragment key={`${chave}-${i}`}>{p}</Fragment>;
  });
}

const PILULA = "inline-flex items-center gap-0.5 rounded bg-[#d9fdd3] px-1 font-medium text-[#0a7d5a]";

/** Comando renderizado como o cliente vê, destacado em verde. */
function Comando({ tipo, exemplo }) {
  if (tipo === "nome") return <span className={PILULA}><UserRound className="h-3 w-3" />{exemplo.nome}</span>;
  if (tipo === "empresa") return <span className={PILULA}><Store className="h-3 w-3" />{exemplo.empresa || "Sua loja"}</span>;
  return <span className="rounded bg-[#d9fdd3] px-1 text-[#027eb5] underline">{`https://${LINK_EXEMPLO}`}</span>;
}

/**
 * Texto do balão. `corpo` pode ter {{n}} (modelo da Meta, preenchidos por
 * `campos`) e os comandos {nome}/{empresa}/{link} (rascunho da loja).
 */
function Corpo({ corpo, campos, exemplo }) {
  const partes = corpo.split(/(\{\{\d+\}\}|\{nome\}|\{empresa\}|\{link\})/g);
  return partes.map((p, i) => {
    const cmd = p.match(/^\{(nome|empresa|link)\}$/);
    if (cmd) return <Comando key={i} tipo={cmd[1]} exemplo={exemplo} />;
    const v = p.match(/^\{\{(\d+)\}\}$/);
    if (v) {
      const c = campos?.[Number(v[1]) - 1];
      if (!c) return <span key={i} className="rounded border border-dashed border-[#25d366] px-1 text-[#0a7d5a]/70">campo {v[1]}</span>;
      if (c.tipo !== "texto") return <Comando key={i} tipo={c.tipo} exemplo={exemplo} />;
      return c.texto
        ? <span key={i} className="rounded bg-[#d9fdd3] px-1">{c.texto}</span>
        : <span key={i} className="rounded border border-dashed border-[#25d366] px-1 text-[#0a7d5a]/70">campo {v[1]}</span>;
    }
    return <Fragment key={i}>{formatar(p, i)}</Fragment>;
  });
}

/**
 * Balão de mensagem recebida no WhatsApp (branco, com a pontinha) e os botões
 * do modelo embaixo — do jeito que o cliente vê. Só mostra: a edição fica na página.
 */
export default function BalaoModelo({ partes, campos, exemplo, hora = "10:42" }) {
  const { cabecalho, corpo = "", rodape, botoes = [] } = partes || {};
  return (
    <div className="relative max-w-[88%] drop-shadow-[0_1px_0.5px_rgba(11,20,26,0.13)]">
      <span className="absolute -left-[7px] top-0 h-0 w-0 border-r-[8px] border-t-[10px] border-r-transparent border-t-white" />
      <div className={`bg-white px-2.5 pt-1.5 pb-1 text-[#111b21] ${botoes.length ? "rounded-tr-lg" : "rounded-lg rounded-tl-none"}`}>
        {cabecalho && <p className="mb-1 text-[14px] font-bold leading-snug">{cabecalho}</p>}
        <div className="whitespace-pre-wrap break-words text-[14px] leading-[19px]">
          {corpo.trim()
            ? <Corpo corpo={corpo} campos={campos} exemplo={exemplo} />
            : <span className="text-[#8696a0]">A mensagem aparece aqui enquanto você escreve…</span>}
        </div>
        {rodape && <p className="mt-1 text-[12px] text-[#667781]">{rodape}</p>}
        <p className="mt-0.5 text-right text-[11px] text-[#667781]">{hora}</p>
      </div>
      {botoes.map((b, i) => (
        <div key={i} className={`flex items-center justify-center gap-1.5 border-t border-[#e9edef] bg-white py-2 text-[14px] font-medium text-[#027eb5] ${
          i === botoes.length - 1 ? "rounded-b-lg" : ""}`}>
          {b.tipo === "link" ? <ExternalLink className="h-4 w-4" /> : b.tipo === "ligar" ? <Phone className="h-4 w-4" /> : <Reply className="h-4 w-4" />}
          {b.texto}
        </div>
      ))}
    </div>
  );
}
